import React, { useState, useEffect } from 'react';
import { DeliveryService } from '../Services/DeliveryService';
import { makeStyles } from '@material-ui/core/styles';
import { Table, TableHead, TableRow, TableCell, Typography, Grid, Paper, TableBody, Fade, CircularProgress, Divider } from '@material-ui/core';
import EnhancedTableToolbar from '../components/EnhancedTableToolbar';
import XLSX from 'xlsx';
import moment from 'moment';
import { formatNumber, format_date_only_new, format_fancy, getTimeInIST } from '../Utils';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3),
        overflow: 'auto',
    },
    table: {
        height: 550,
        overflow: 'auto',
    }
  })
);

function StoresWithNoRecentOrders(props) {
    const classes = useStyles();
    const [fetch, setFetch] = useState(false);
    const [stores, setStores] = useState([]);
    const [originalStores, setOriginalStores] = useState([]);
    const [rows, setRows] = useState([]);
    const [totalPending, setTotalPending] = useState(0);
    const [totalOverdue, setTotalOverdue] = useState(0);

    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        props.setTitle('Store Outstanding Ledger');
        setFetch(true);
        props.isLoading(true);
        DeliveryService.getStoreOutstandingLedger()
        .then((data) => {
            let total_amount = 0;
            console.log(data.report);
            setStores(data.report);
            setOriginalStores(data.report);
            setTotalPending(data.report.reduce(function(accumulator, currentValue){
                return accumulator + parseFloat(currentValue.pending_amount);
            }, total_amount));
            total_amount = 0;
            setTotalOverdue(data.report.reduce(function(accumulator, currentValue){
                return accumulator + parseFloat(currentValue.overdue_amount);
            }, total_amount));
            setFetch(false);
            props.isLoading(false);
        })
        .catch((error) => {
            setFetch(false);
            props.isLoading(false);
        })
    }, []);

    useEffect(() => {
        let rows = [];
        stores.forEach((element, index) => {
            rows.push(
            <TableRow key={index}>
                <TableCell>
                    <Typography variant="subtitle1" color="textPrimary">{index + 1}</Typography>
                </TableCell>
                <TableCell>
                    <Typography variant="subtitle1" color="textPrimary">{element.store_name}</Typography>
                </TableCell>
                <TableCell align="right">
                    <Typography variant="subtitle1" color="textPrimary">{element.name}</Typography>
                </TableCell>
                <TableCell align="right">
                    <Typography variant="subtitle1" color="textPrimary">{element.mobile_no}</Typography>
                </TableCell>
                <TableCell align="right">
                    <Typography variant="subtitle1" color="textPrimary">{element.incharge ? element.incharge : 'Not Assigned'}</Typography>
                </TableCell>
                <TableCell align="right">
                    <Typography variant="subtitle1" color="textPrimary">{formatNumber(element.pending_amount)}</Typography>
                </TableCell>
                <TableCell align="right">
                    <Typography variant="subtitle1" color="textPrimary">{formatNumber(element.overdue_amount)}</Typography>
                </TableCell>
                <TableCell>
                    <Typography variant="subtitle1" color="textPrimary">{element.last_ledger_date ? getTimeInIST(element.last_ledger_date).format(format_fancy): "-"}</Typography>
                </TableCell>
            </TableRow>)
        });
        setRows(rows);
    }, [stores])

    function exportReport() {
        if(originalStores && originalStores.length > 0){
            let sheetname = 'Store Outstanding Report';
            let exportData = [];
            exportData = [["Sl No", "Store", "Manager", "Mobile", "Incharge", "Pending Amount", "Overdue Amount", "Last Synced on"]];
            originalStores.forEach((row, index) => {
                    exportData.push([index+1, row.store_name, row.name, row.mobile_no, row.incharge ? row.incharge : 'Not Assigned', row.pending_amount, row.overdue_amount, row.last_ledger_date ? moment(row.last_ledger_date).format(format_date_only_new): "-"]);
            });

            if(exportData){
                const wb = XLSX.utils.book_new();
                const wsAll = XLSX.utils.aoa_to_sheet(exportData);
                XLSX.utils.book_append_sheet(wb, wsAll, sheetname );
                XLSX.writeFile(wb, sheetname + ".xlsx");
            }
        } else {
            this.props.showSnackBar('Nothing to export', 'error');
        }
    }

    function filterCriteria(e){
        let searchText = "";
        if(e){
            e.preventDefault();
            searchText = e.target.value || "";
            let filteredList = [];
            if(searchText.length !== 0){
                filteredList = originalStores.filter(data => data.store_name.toLowerCase().includes(searchText.toLowerCase()));
            } else {
                filteredList = originalStores;
            }
            setStores(filteredList);
        }
        setSearchText(searchText);
    }

    return (
        <div className="Home">
				<div className="">
				<Grid container spacing={2} style={{marginTop: 32}}>
                    <Grid item lg={12} xs={12}>
                        <Paper className={classes.root}>
                            <EnhancedTableToolbar title="" exportReport={exportReport} onSearchTextChange={filterCriteria} searchText={searchText}/>
                            <div className={classes.table}>
                                <Table size="small" stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                            </TableCell>
                                            <TableCell>
                                                <Typography variant="h6" color="textPrimary">Store</Typography>
                                            </TableCell>
                                            <TableCell align="right">
                                                <Typography variant="h6" color="textPrimary">Manager</Typography>
                                            </TableCell>
                                            <TableCell align="right">
                                                <Typography variant="h6" color="textPrimary">Mobile</Typography>
                                            </TableCell>
                                            <TableCell align="right">
                                                <Typography variant="h6" color="textPrimary">HappyMilk Incharge</Typography>
                                            </TableCell>
                                            <TableCell align="right">
                                                <Typography variant="h6" color="textPrimary">Pending Amount</Typography>
                                            </TableCell>
                                            <TableCell align="right">
                                                <Typography variant="h6" color="textPrimary">Overdue Amount</Typography>
                                            </TableCell>
                                            <TableCell style={{width: 130}}>
                                                <Typography variant="h6" color="textPrimary">Last Synced on</Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows}
                                    </TableBody>
                                </Table>
                                <Fade
                                    in={fetch}
                                    style={{
                                        transitionDelay: fetch ? '10ms' : '0ms'
                                    }}
                                    unmountOnExit
                                    >
                                    <CircularProgress style={{marginTop: 20}}/>
                                </Fade>
                            </div>
                            <Divider />
                            <div style={{float: 'right', marginRight: 24}}>
                                <Typography variant="h6" color={totalPending > 0 || totalOverdue > 0 ? "secondary" : "textPrimary"}>
                                    <React.Fragment>
                                        <span style={{marginRight: 32}}>Total Pending: {formatNumber(totalPending)}</span><span>Total Overdue: {formatNumber(totalOverdue)}</span>
                                    </React.Fragment>
                                </Typography>
                            </div>
                        </Paper>
                    </Grid>
				</Grid>
            </div>
        </div>
      );
};

export default StoresWithNoRecentOrders;